export const ClaimMenu  = {
    disabled: false,
    loading: false,
    icon: "fas fa-tags",
    emit: "kooi:create:claim",
    key: "new_claims",
    text: "labels.claim.create",
    data: {
        id : "+",
    }
}
